<script setup lang="ts">
defineExpose({
  name: 'licenseSkeleton',
});
</script>

<template>
  <div class="licenseSkeleton">
    <div class="licenseSkeleton__licenseSkeleton">
      <div class="licenseSkeleton__mainHeader shimmer"></div>
      <div class="licenseSkeleton__inner">
        <div class="licenseSkeleton__header shimmer"></div>
        <div class="licenseSkeleton__barDiv">
          <div class="licenseSkeleton__bar shimmer"></div>
          <div class="licenseSkeleton__button shimmer"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_pageForward.scss' as *;

.licenseSkeleton {
  position: relative;
  margin-top: $service-unit * 3;

  &__licenseSkeleton {
    background-color: $color-white-100;
    box-shadow: $service-shadow-mp;
    padding: $service-unit * 3;
    border-radius: $service-border-radius * 2;
    overflow: hidden;
    width: 100%;
  }

  &__mainHeader,
  &__header {
    height: $service-unit * 6;
    background-color: $color-gray-20;
    border-radius: $service-border-radius * 2;
  }

  &__mainHeader {
    width: 100% * calc(50 / 150);
    margin: $service-unit * 2;
  }

  &__header {
    width: 100% * calc(50 / 200);
  }

  &__inner {
    padding: $service-unit * 3;
    width: 100%;
  }

  &__barDiv {
    display: flex;
    justify-content: space-between;
  }

  &__bar {
    height: $service-unit * 4;
    background-color: $color-gray-20;
    border-radius: $service-border-radius * 2;
    margin-top: $service-unit * 2;
    width: 100% * calc(50 / 100);
  }

  &__button {
    width: 100% * calc(50 / 400);
    height: $service-unit * 8;
    margin-top: $service-unit * 3;
    background-color: $color-gray-20;
    border-radius: $service-border-radius * 2;
  }
}
</style>
